import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ProjectListPage } from '@/pages/projects/ui/ProjectListPage';
import { paginationSchema, routeValidateQuerySearch } from '@/shared/lib/route';

// URLクエリパラメータのスキーマ
// 検索条件はすべて QueryStore（POST /project-query-stores）に永続化し、URL には query_store_id のみを反映する。
const projectsSearchSchema = paginationSchema.extend({
  query_store_id: z.string().uuid().optional(),
  // ソート（複数カラム・優先順付き）。BE 仕様に合わせ、各要素は `<field>` または
  // `<field>:<direction>`（direction は asc/desc）形式の文字列。未指定時は BE が
  // 「会計CD→款CD→項CD→目CD→事業CD→事業名」の昇順を適用する。
  // 不正値は parseProjectSortConditions で寛容に弾く方針のため、ここでは string[] のみ検証する。
  sort: z.array(z.string()).optional(),
});

export const Route = createFileRoute('/_protected/projects/')({
  component: ProjectListPage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: true,
      withPaginationSchema: projectsSearchSchema,
      defaultValues: undefined,
    }),
});
